// extracted by mini-css-extract-plugin
export default {"base":"SearchPopover_base__WGC5X","open":"SearchPopover_open__AdeOG"};